import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessService } from '../mess.service';

@Component({
  selector: 'app-mess-landing-page',
  templateUrl: './mess-landing-page.component.html',
  styleUrls: ['./mess-landing-page.component.scss']
})
export class MessLandingPageComponent implements OnInit {
  isCollapsed: boolean = false;
  isContainerCollapsed: boolean = true;

  reportsActive = false;

  containerWidth = '';

  activeView = 'mealOrderSummary';
  roleDetails: any;

  Grievanceuser1 = false;
  Grievanceuser2 = false;
  constructor(private Service: MessService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.Service.collapsed$.subscribe(state => {
      this.isCollapsed = state;
    });
    this.Service.view$.subscribe(view => {
      this.activeView = view;
      // console.log('this.activeView',this.activeView);
    });
     this.Service.width$.subscribe(width => {
      this.containerWidth = width;
    });

    this.Service.reportsSelected$.subscribe(flag => {
    this.reportsActive = flag;
  });
  
  }

}
